import * as React from 'react'

import { Checkbox } from '../checkbox/Checkbox'
import { CheckboxGroupCheckedContext } from './context/CheckboxGroupChecked.context'
import { CheckboxGroupMountedContext } from './context/CheckboxGroupMounted.context'

type CheckboxGroupAllItemProps = Omit<
  React.ComponentProps<typeof Checkbox>,
  'checked' | 'defaultChecked'
>

export const CheckboxGroupAllItem = ({
  onCheckedChange,
  title = 'all',
  ...rest
}: CheckboxGroupAllItemProps): React.JSX.Element => {
  const {
    checked: checkedItems,
    handleItemCheckedChange: handleItemCheckedChangeContext
  } = React.useContext(CheckboxGroupCheckedContext)
  const { mounted: mountedItems } = React.useContext(
    CheckboxGroupMountedContext
  )

  const handleItemCheckedChange = (newChecked) => {
    mountedItems.forEach((value) => {
      handleItemCheckedChangeContext(newChecked, value)
    })
    onCheckedChange?.(newChecked)
  }

  const isAllChecked = (() => {
    if (!checkedItems.length || !mountedItems.length) return false

    if (mountedItems.every((mountedItem) => checkedItems.includes(mountedItem)))
      return true

    if (mountedItems.some((mountedItem) => checkedItems.includes(mountedItem)))
      return 'indeterminate'

    return false
  })()

  return (
    <Checkbox
      onCheckedChange={handleItemCheckedChange}
      checked={isAllChecked}
      title={title}
      {...rest}
    />
  )
}
